import { makeStyles } from 'tss-react/mui'
import { navBarHeaderHeight } from '../../lib/Constants'

export const rightPanelStyles = makeStyles()(theme => ({
  dividerAlt: {
    marginTop: '20px',
    marginBottom: '5px'
  },
  itemsInputFieldMessage: {
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.colors.text,
    paddingBottom: '15px'
  },
  customText: {
    fontWeight: 700,
    fontStyle: 'italic',
    color: theme.colors.text
  },
  bottomSpace: {
    height: '200px'
  },
  rightPanelContainer: {
    width: '323px',
    minWidth: '323px',
    boxShadow: '-10px 0px 10px -10px rgba(0, 0, 0, 0.2)',
    height: '100%'
  },
  emptyMessageContainer: {
    background: theme.colors.pink,
    height: '97px',
    margin: '30px',
    borderRadius: '8px',
    border: `1px solid ${theme.colors.logInDisabledBackground}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: '24px',
    paddingLeft: '24px'
  },
  emptyMessageTytleStyle: {
    fontSize: '16px',
    color: theme.colors.text
  },
  continueMessageContainer: {
    justifyContent: 'center',
    paddingRight: '30px',
    paddingLeft: '30px',
    marginTop: '50px'
  },
  continueMessageTitle: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '18px',
    color: theme.colors.text,
    paddingBottom: '16px'
  },
  continueMessageText: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    color: theme.colors.textButton
  },
  itemName: { paddingBottom: '10px', fontSize: '18px', fontWeight: 500 },
  secondaryContainer: { height: '90%' },
  contentContainer: {
    paddingTop: '20px',
    height: '90%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  itemNameConatiner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  actionIconsConatiner: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'flex-start',
    marginTop: '-6px',
    padding: '0 10px 0 0'
  },
  actionDisabled: {
    color: theme.colors.textGray
  },
  actionIcons: {
    fontSize: '16px',
    color: theme.colors.text
  },
  actionIconsDisabled: {
    fontSize: '16px',
    color: theme.colors.textGray
  },
  actionText: {
    fontSize: '7px',
    color: theme.colors.text
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '10px',
    marginBottom: '5px',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '8px 0'
  },
  removeIconsButton: {
    color: theme.colors.grayText,
    margin: '0 8px',
    padding: '0',
    textAlign: 'center',
    width: 'fit-content',
    minWidth: 'fit-content',
    '&:hover': {
      backgroundColor: 'inherit',
      borderColor: 'inherit',
      boxShadow: 'none'
    },
    '&.Mui-disabled': {
      color: theme.colors.gray2
    }
  },
  titleSymbol: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.redError
  },
  titleFontStyle: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.gray
  },
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '18px',
      fontSize: '12px',
      height: '99px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: `0 0 0 1000px ${theme.colors.white} inset`
      }
    }
  },
  box: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  buttonList: {
    minHeight: 'inherit'
  },
  divider: {
    margin: '20px 0',
    borderWidth: '0.5px 0px',
    borderColor: theme.colors.textGray
  },
  itemNameContainer: { padding: '20px' },
  emptyStateTitle: {
    fontSize: '16px',
    color: theme.colors.text
  },
  emptyMessageText: {
    fontSize: '12px',
    color: theme.colors.textButton
  }
}))

export const leftPanelStyles = makeStyles()(theme => ({
  searchField: {
    width: '80%'
  },
  tabsDivider: {
    margin: '10px',
    height: '20px',
    alignSelf: 'center'
  },
  lockIcon: {
    marginRight: '-10px'
  },
  elementsTabContainer: {
    border: `2px dashed ${theme.colors.white}`,
    height: 'calc(100% - 200px)',
    borderRadius: '18px'
  },
  elementsTabContainerRedBorder: {
    border: `2px dashed ${theme.colors.borderRedError}`
  },
  pagesTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  pagesListContainer: {
    height: 'calc(100% - 120px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  searchContainer: {
    paddingTop: '20px',
    paddingBottom: '20px'
  },
  panelPagesTitle: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.colors.textGray,
    paddingBottom: '20px'
  },
  tabIndicator: {
    width: '30px !important',
    top: '30px'
  },
  elementText: {
    fontSize: 14,
    color: theme.colors.text
  },
  elementContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  cursorStyle: {
    marginRight: '8px'
  },
  closeIcon: {
    paddingTop: '20px',
    paddingBottom: '20px'
  },
  pagesText: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.colors.textGray,
    paddingBottom: '20px'
  },
  fileIconStyle: {
    paddingRight: '9px'
  },
  pagesCounterText: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.colors.text
  },
  searchBar: {
    borderRadius: '18px',
    height: '36px',
    fontSize: '14px'
  },
  leftPanelContainer: {
    width: '323px',
    minWidth: '323px',
    background: theme.colors.white,
    height: '100%',
    boxShadow: '10px 0px 10px -10px rgba(0, 0, 0, 0.2)'
  },
  detailsContainer: {
    paddingRight: '10px',
    paddingLeft: '16px'
  },
  titleContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  infoIconStyle: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.colors.text
  },
  textTabsStyles: {
    minWidth: '20px',
    fontSize: 12,
    textTransform: 'none',
    alignItems: 'start',
    padding: 0
  },
  panelsConstainer: {
    flex: 1,
    height: '100%'
  },
  structureTab: {
    paddingLeft: '16px',
    paddingRight: '14px',
    height: 'calc(100% - 150px)'
  },
  tabsContainer: { marginLeft: '16px' },
  structureMessage0: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.textButton,
    textAlign: 'center',
    paddingRight: '30px',
    paddingLeft: '30px',
    paddingBottom: '10px'
  },
  structureMessage1: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.textButton,
    textAlign: 'center',
    fontStyle: 'italic'
  },
  addElementsMessage: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.textButton,
    textAlign: 'center',
    paddingRight: '30px',
    paddingLeft: '30px',
    paddingBottom: '10px'
  },
  addIcon: {
    fontSize: '20px',
    color: theme.colors.darkBlue
  },
  pagesAddIcon: {
    fontSize: '20px',
    color: theme.colors.textGray
  },
  sectionsTitle: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.colors.text,
    paddingBottom: '15px',
    paddingTop: '15px'
  },
  sectionsContainer: { paddingLeft: '25px' },
  pageCounter: { fontSize: '14px', fontWeight: 400, color: theme.colors.text },
  pageCounterContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  pageIcon: { paddingRight: '9px' },
  arrowIconButton: { marginRight: '-10px' },
  draggableContainer: {
    height: '100%'
  },
  descriptionContainer: {
    width: '100%'
  }
}))

export const middlePanelStyles = makeStyles()(theme => ({
  middlePanelContainer: {
    width: '100%',
    background: theme.colors.white,
    height: '100%'
  },
  fileIcon: {
    fontSize: '14px',
    color: theme.colors.textGray
  },
  bottomComponent: {
    paddingTop: '100px'
  },
  elementsSeparation: {
    paddingBottom: '10px'
  },
  droppableContainerActive: {
    border: `2px dashed ${theme.colors.borderBlue}`
  },
  droppableContainer: {
    border: `2px dashed ${theme.colors.white}`,
    borderRadius: '18px'
  },
  sectionsContainer: {
    overflowY: 'auto',
    height: 'calc(100% - 230px)'
  },
  handleStyle: {
    borderWidth: 0,
    background: 'white',
    width: '60%',
    height: '20px'
  },
  elementSectionTitle: {
    '& .MuiInputBase-input': {
      width: 'fit-content',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    input: {
      '-webkit-text-fill-color': 'black !important',
      color: 'black !important'
    }
  },
  elementCounterContainer: {
    marginRight: '5px'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  sectionSelector: {
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center'
  },
  sectionTitle: {
    width: '100%',
    fontSize: '12px',
    fontWeight: 500,
    color: theme.colors.text,
    '& .MuiInputBase-input': {
      width: 'fit-content',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    input: {
      '-webkit-text-fill-color': 'black !important',
      color: 'black !important'
    }
  },
  dataCounterText: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.textButton
  },
  arrow: {
    fontSize: '16px',
    fontWeight: 500,
    color: theme.colors.text
  },
  tabIndicator: {
    width: '30px !important',
    top: '30px'
  },
  tabsContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  lockIcon: {
    marginRight: '-10px'
  },
  tabText: {
    fontSize: 12,
    textTransform: 'none',
    alignItems: 'start',
    padding: 0
  },
  emptyComponentContainer: {
    background: theme.colors.lightBlue,
    height: '97px',
    borderRadius: '8px',
    border: `1px solid ${theme.colors.logInDisabledBackground}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: '24px',
    paddingLeft: '24px'
  },
  emptyMessageTitle: {
    fontSize: '16px',
    color: theme.colors.text,
    fontWeight: 500
  },
  emptyMessage: {
    fontSize: '12px',
    color: theme.colors.textButton
  },
  secondaryBarContainer: {
    marginBottom: '12px',
    marginTop: '20px'
  },
  selector: {
    marginRight: '30px',
    width: '300px',
    borderRadius: '18px',
    height: '36px',
    fontSize: '14px'
  },
  searchBar: {
    width: '300px',
    borderRadius: '18px',
    height: '36px',
    fontSize: '14px'
  },
  modeTitle: {
    fontSize: 18,
    alignSelf: 'center',
    textAlign: 'center'
  },
  previewButton: {
    borderRadius: 25,
    color: theme.colors.gray2,
    textTransform: 'none',
    background: theme.colors.iconBlue,
    width: 115,
    fontSize: '13px',
    fontWeight: 700,
    height: '41px',
    '&.Mui-disabled': {
      borderColor: theme.colors.textGray,
      color: theme.colors.textGray,
      backgroundColor: theme.colors.white
    },
    '&:hover': {
      backgroundColor: theme.colors.iconBlue
    }
  },
  saveButton: {
    borderRadius: 25,
    color: theme.colors.gray2,
    textTransform: 'none',
    background: theme.colors.iconBlue,
    width: 95,
    fontSize: '13px',
    fontWeight: 700,
    height: '41px',
    '&.Mui-disabled': {
      background: theme.colors.logInDisabledBackground,
      color: theme.colors.textButton
    },
    '&:hover': {
      backgroundColor: theme.colors.iconBlue
    }
  },
  rightButton: {
    borderRadius: 25,
    color: theme.colors.gray2,
    textTransform: 'none',
    background: theme.colors.iconBlue,
    width: 115,
    fontSize: '13px',
    fontWeight: 700,
    height: '41px',
    '&.Mui-disabled': {
      borderColor: theme.colors.textGray,
      color: theme.colors.textGray,
      backgroundColor: theme.colors.white
    },
    '&:hover': {
      backgroundColor: theme.colors.iconBlue
    }
  },
  draggedComponentsContainer: {
    overflowY: 'auto',
    height: 'calc(100% - 270px)'
  },
  emptySearchContainer: {
    paddingTop: '80px',
    paddingRight: '70px',
    paddingLeft: '70px'
  },
  emptySeachMessage: {
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '30px',
    textAlign: 'center',
    color: theme.colors.textButton
  }
}))

export const draggableElementStyles = makeStyles()(theme => ({
  container: {
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  containerGray: {
    background: theme.colors.gray2
  },
  iconButton: { '&:hover': { backgroundColor: theme.colors.gray2 } },
  errorIcon: {
    fontSize: '15px',
    color: theme.colors.textGray
  },
  addIcon: {
    fontSize: '24px',
    color: theme.colors.darkBlue
  }
}))

export const draggedElementStyles = makeStyles()(theme => ({
  disabledTitle: {
    fontSize: '20px',
    fontWeight: 550,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    WebkitBoxOrient: 'vertical'
  },
  form: {
    width: '100%'
  },
  itemNameContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  cursorIcon: {
    marginRight: '8px',
    fontSize: '16px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '87px',
    paddingRight: '20px',
    paddingLeft: '20px',
    paddingTop: '15px',
    paddingBottom: '7px',
    borderRadius: '18px',
    background: theme.colors.white,
    justifyContent: 'space-between'
  },
  titlePlaceholder: {
    border: 'none',
    fontSize: '16px',
    fontWeight: 500,
    color: theme.colors.textGray,
    height: '30%',
    lineHeight: '19px',
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: theme.colors.text
    },
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  iconDisabled: {
    fontSize: '14px',
    marginRight: '8px',
    color: theme.colors.textGray
  },
  iconEnabled: { fontSize: '14px', marginRight: '8px' },
  fontDisabled: { fontSize: '12px', color: theme.colors.textGray },
  fontEnabled: { fontSize: '12px' },
  iconTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  itemName: { fontSize: 12, color: theme.colors.text },
  elementContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}))

export const droppableStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    height: '100%',
    background: theme.colors.white
  },
  droppableStyle: {
    margin: '15px',
    width: '100%',
    height: '100%',
    borderRadius: 5
  },
  middlePanelContainer: {
    background: theme.colors.white,
    height: '100%'
  },
  droppedComponentsList: {
    overflowY: 'auto',
    height: '100%'
  }
}))

export const formBuilderMainStyles = makeStyles()(theme => ({
  ring: {
    color: theme.colors.loadingRing
  },
  boldText: {
    color: theme.colors.text,
    fontWeight: 700
  },
  destructiveButton: {
    backgroundColor: theme.colors.redError,
    borderRadius: '36px',
    width: '115px',
    textTransform: 'none',
    borderColor: theme.colors.redError,
    color: theme.colors.white,
    fontSize: '14px',
    fontWeight: 700,
    '&.MuiButton-contained:hover': {
      backgroundColor: theme.colors.redError
    }
  },
  loaderContainer: {
    marginTop: '25%',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formBuilderTabsContainer: {
    width: '100%',
    height: '100%',
    position: 'fixed'
  },
  panelsStack: {
    height: '100%',
    width: '100%'
  }
}))

export const elementStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: '16px',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    height: '44px'
  },
  imageContainer: { fontSize: '16px', minWidth: '30px' },
  text: { fontSize: 14, color: theme.colors.text },
  disabled: { color: theme.colors.textGray }
}))

export const topBarStyles = makeStyles()(theme => ({
  formTitleStyle: {
    marginRight: '20px',
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    input: {
      '-webkit-text-fill-color': `${theme.colors.text} !important`,
      color: `${theme.colors.text} !important`
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: navBarHeaderHeight,
    paddingLeft: '30px',
    paddingRight: '50px'
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center'
  },
  FormNameText: {
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  lockIcon: { paddingRight: '14px' },
  backButton: { marginRight: '10px' }
}))

export const auditTrailTabStyles = makeStyles()(theme => ({
  bottomPadding: {
    paddingBottom: '50px'
  },
  itemContainer: {
    display: 'flex'
  },
  avatar: {
    background: theme.colors.gray,
    marginRight: '17px',
    fontSize: '12px',
    fontWeight: 600
  },
  itemActionText: {
    color: theme.colors.description,
    fontSize: '12px',
    fontWeight: 500
  },
  userInfoText: {
    color: theme.colors.description,
    fontSize: '10px',
    fontWeight: 400
  },
  tabContainer: {
    height: 'calc(100% - 170px)',
    paddingTop: '39px',
    paddingLeft: '57px',
    overflow: 'auto'
  },
  loadingContainer: {
    height: '90%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  separatorStyle: {
    height: '33px',
    marginLeft: '19px',
    borderLeft: `1px dashed ${theme.colors.gray}`
  }
}))

export const sectionListItemStyles = makeStyles()(theme => ({
  text: {
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: theme.colors.text
    }
  },
  container: {
    paddingLeft: '25px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  containerGray: {
    background: theme.colors.gray2
  },
  iconButton: { '&:hover': { backgroundColor: theme.colors.gray2 } },
  errorIcon: {
    fontSize: '15px',
    color: theme.colors.textGray
  },
  inputStyle: {
    fontSize: '14px',
    fontFamily: 'Rubik',
    lineHeight: '16px',
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  rectangleIcon: {
    fontSize: '16px',
    paddingRight: '8px'
  },
  trashIcon: {
    fontSize: '14px',
    color: theme.colors.text
  },
  containerStyle: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '44px',
    fles: 1
  }
}))
